const headerWithToken = {
    headers: {
      'Content-Type': 'Application/json',
      'Authorization' : 'Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJBRE1JTl9TUFQiLCJpc0FkbWluIjp0cnVlLCJleHAiOjQyMDI1MzQxODEsImlhdCI6MTYxMDUzNDE4MX0.Rj4OWUQjq-gIdm0i7qXxgBv4W5sPehZvy_6_9SR0m5-B4Q_W2pjTAz8QcZrUDVOwtWPtj4udxWXVhChNGN8mVg'
      // 'Authorization' : 'Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiI5OTI1Mjk5NDE5IiwiaXNVc2VyIjp0cnVlLCJleHAiOjQxOTk0OTc5NzgsImlhdCI6MTYwNzQ5Nzk3OH0.1Weet_DCaiwRdQ3489JgWvh2YFRPFhI0DJpGZ1Co_iiCFpUviTf0reg_iKdHW89AzZoPysgd0d7SGExxUSKLTw'
    },
  }
export default headerWithToken;